// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Source = /** @class */ (function () {
    function Source(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(Source.prototype, "from", {
        /**
         * source_from 参数
         */
        get: function () {
            var source_from = this.adapter.getStore().source_from;
            return source_from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Source.prototype, "uid", {
        /**
         * source_uid 参数
         */
        get: function () {
            var source_uid = this.adapter.getStore().source_uid;
            return source_uid;
        },
        enumerable: false,
        configurable: true
    });
    return Source;
}());
export { Source };
